import { useQuery } from '@apollo/client';
import { LIST_SCORING_BATCHES } from '@gql/scoring';
import { ScoringBatchListResult } from '../types';

export const useListScoringBatches = (page = 1, limit = 20) => {
    const { data, loading, error, refetch } = useQuery<
        { listScoringBatches: ScoringBatchListResult },
        { page: number; limit: number }
    >(LIST_SCORING_BATCHES, {
        variables: { page, limit },
        fetchPolicy: 'cache-and-network',
    });

    return {
        result: data?.listScoringBatches ?? null,
        docs: data?.listScoringBatches?.docs ?? [],
        totalDocs: data?.listScoringBatches?.totalDocs ?? 0,
        totalPages: data?.listScoringBatches?.totalPages ?? 0,
        loading,
        error,
        refetch,
    };
};
